import { Component, Input, OnInit } from '@angular/core';
import { LoadingPanelComponent } from '../../core/panels/loading-panel.component';
import { ColumnComponent } from '../../core/table/column.component';
import { TableComponent } from '../../core/table/table.component';
import { ClaimLabelComponent } from '../../core/labels/claim-label.component';
import { ClaimInfoRelatedClaim } from '../../../models/api/view/claim/header/claiminforelatedclaim';
import { ClaimRow } from '../../../models/api/view/claim-view/claim-row';
import { BaseComponent } from '../../base/base.component';
import { HandleLoadingState } from '../../../decorators/handle-loading-state.decorator';
import { DialogComponent } from '../../core/panels/dialog.component';
import { ActionRowComponent } from '../../core/panels/action-row.component';
import { ButtonComponent } from '../../core/buttons/button.component';
@Component({
  selector: 'app-related-claims',
  imports: [
    LoadingPanelComponent,
    TableComponent,
    ColumnComponent,
    ClaimLabelComponent,
    DialogComponent,
    ActionRowComponent,
    ButtonComponent,
  ],
  template: ` <app-loading-panel
      [state]="loading ? 'Loading' : 'Loaded'"
      [error]="error"
    >
      <ng-template #loaded>
        <app-table
          [dataSource]="dataSource"
          [pageSize]="pageSize"
          recordLabel="claim"
          recordLabelPlural="claims"
          [showExport]="false"
          [showToolbar]="true"
          [sortField]="sortField"
          [sortOrder]="sortOrder"
          [error]="error"
          [globalFilterFields]="[
            'claimCaseNumber',
            'lineCode',
            'coverageCode',
            'status',
            'claimantFirstName',
          ]"
        >
          <app-column name="claimCaseNumber" label="Claim number" width="20%">
            <ng-template let-data>
              <app-claim-label
                [claim]="data"
                [fileNumber]="data.claimCaseNumber"
                [recordId]="data.recordId"
                [recordSource]="data.recordSource"
                [sensitiveAccessStatus]="data.sensitiveAccessStatus"
                (sensitiveBlocked)="onSensitiveBlocked($event)"
              />
            </ng-template>
          </app-column>
          <app-column name="lineCode" label="Line" width="20%" />
          <app-column name="coverageCode" label="Coverage" width="20%" />
          <app-column name="status" label="Claim status" width="20%" />
          <app-column name="claimantFirstName" label="Claimant" width="20%">
            <ng-template #value let-item>
              {{ item.claimantFirstName }} {{ item.claimantLastName }}
            </ng-template>
          </app-column>
        </app-table>
      </ng-template>
    </app-loading-panel>

    <app-dialog
      label="Sensitive Claim Access"
      [(visible)]="sensitiveDialogVisible"
      width="40rem"
    >
      <ng-template #content>
        <div class="tw-whitespace-pre-line tw-pb-6">
          {{ sensitiveMessage }}
        </div>
        <app-action-row>
          <app-button
            right1
            label="OK"
            labelCase="none"
            (click)="sensitiveDialogVisible = false"
          />
        </app-action-row>
      </ng-template>
    </app-dialog>`,
  styles: [],
})
export class RelatedClaimsComponent extends BaseComponent implements OnInit {
  @Input()
  dataSource: any[] = [];

  @Input()
  pageSize = 5;

  @Input()
  sortField: string;

  @Input()
  sortOrder: number;

  claimRow: ClaimRow;
  relatedClaims: ClaimInfoRelatedClaim[] = [];
  loading = false;
  error: any = null;

  sensitiveDialogVisible = false;
  sensitiveMessage = '';

  @HandleLoadingState()
  async ngOnInit() {
    this.claimRow = this.view.currentClaim();
    if (
      this.claimRow.lineOfBusiness === 'DS' ||
      this.claimRow.lineOfBusiness === 'WC' ||
      this.claimRow.lineOfBusiness === 'GL' ||
      this.claimRow.lineOfBusiness === 'PR' ||
      this.claimRow.lineOfBusiness === 'AU'
    ) {
      this.dataSource = await this.api.claimHeader.getRelatedClaim(
        this.claimRow.recordSource,
        this.claimRow.recordId,
      );
    }
  }

  onSensitiveBlocked(message: string) {
    this.sensitiveMessage = message;
    this.sensitiveDialogVisible = true;
  }
}
